import GeneralServices from "./GeneralServices";
import { Funcionalidad, ILiteralesResponse } from "./LiteralesServices.dto";
import { BaseServiceRequestDto } from "./dto/request/BaseServiceRequest.dto";

class LiteralesServices {
  getLiteralesCross = async ({
    setLoading,
    loader,
  }: BaseServiceRequestDto): Promise<any> => {
    try {
      const response = await GeneralServices.get({
        setLoading,
        loader,
        endpoint: `literal?function=${Funcionalidad.Cross}`,
      });
      const data: ILiteralesResponse[] = response.data
      return {
        ok: true,
        data,
      };
    } catch (error) {
      return {
        error: true,
        message: typeof error === "string" ? error : "No se han recuperado los textos, por favor, recargue la página.",
      }
    }
  };
}

export default new LiteralesServices();
